const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const request = async (path, init = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  });

  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      const payload = await response.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // noop
    }
    throw new Error(detail);
  }

  return response.json();
};

export const fetchCustomerExperienceSummary = () => request('/api/customer-experience/summary');
export const fetchCustomerExperienceOverview = () => request('/api/customer-experience/overview');
export const fetchCustomerExperienceAreas = (areaId = null) => {
  const suffix = areaId ? `?area_id=${encodeURIComponent(areaId)}` : '';
  return request(`/api/customer-experience/areas${suffix}`);
};
export const fetchCustomerProactiveOutreach = () => request('/api/customer-experience/proactive-outreach');
export const fetchHighRiskCustomers = () => request('/api/customer-experience/high-risk-customers');
export const fetchCustomerExperienceDetail = (customerId) => request(`/api/customer-experience/customers/${encodeURIComponent(customerId)}`);
